var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGermany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74658 19.1739C5.4421 23.7435 9.84061 27 15.0002 27C20.1598 27 24.5583 23.7435 26.2538 19.1739L15.0002 18.1305L3.74658 19.1739Z",
    fill: "#FFDA44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 3C9.84061 3 5.4421 6.2565 3.74658 10.8261L15.0002 11.8695L26.2538 10.8261C24.5583 6.2565 20.1598 3 15.0002 3Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74639 10.826C3.26405 12.126 3 13.5321 3 14.9999C3 16.4678 3.26405 17.8738 3.74639 19.1738H26.2537C26.736 17.8738 27 16.4678 27 14.9999C27 13.5321 26.736 12.126 26.2536 10.826H3.74639Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermany);
export default __webpack_public_path__ + "static/media/Germany.6266ac0c92da44404dee4fbc817382b7.svg";
export { ForwardRef as ReactComponent };